import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-approval-request',
  templateUrl: './approval-request.component.html',
  styleUrls: ['./approval-request.component.css']
})
export class ApprovalRequestComponent implements OnInit {
  private gridApi: GridApi;
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  approvalRequestcolumnDefs = [
    {headerName: 'Agent Name', field: 'creator_name', resizable: true, sortable: true, filter: true, checkboxSelection: true,headerCheckboxSelection: true,selectedNodes:true},
    {headerName: 'Customer Name', field: 'Customer_Name', resizable: true, sortable: true, filter: true},
    {headerName: 'Bank Name', field: 'bank_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Portfolio Name', field: 'portfolio_type', resizable: true, sortable: true, filter: true},
    {headerName: 'TOS', field: 'total_out_standing', resizable: true, sortable: true, filter: true},
    {headerName: 'POS', field: 'pos', resizable: true, sortable: true, filter: true},
    {headerName: 'Product Name', field: 'product_type', resizable: true, sortable: true, filter: true},
    {headerName: 'Territory Name', field: 'fieldvisitterritory', resizable: true, sortable: true, filter: true},
    {headerName: 'Status', field: 'approval_status', resizable: true, sortable: true, filter: true},
    {headerName: 'FV Done Date', field: 'FV_Done_Date', resizable: true, sortable: true, filter: true},
    {headerName: 'Phone Numbers Obtained', field: 'Numbers_Obtained', resizable: true, sortable: true, filter: true},
    {headerName: 'FV Coordinater Feedback', field: 'FV_Feedback', resizable: true, sortable: true, filter: true},
    {headerName: 'Area Name', field: 'fieldvisitarea', resizable: true, sortable: true, filter: true},
    {headerName: 'First Address', field: 'firstaddress', resizable: true, sortable: true, filter: true},
    {headerName: 'Second Address', field: 'secondaddress', resizable: true, sortable: true, filter: true},
    {headerName: 'Requested Date', field: 'fvrqdate', resizable: true, sortable: true, filter: true},
    {headerName: 'Remarks', field: 'remarks', resizable: true, sortable: true, filter: true},
    {headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true},
    // {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
 
   
    // {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},

    // {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    
    // {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Passport Number', field: 'passport_no', resizable: true, sortable: true, filter: true},
   
    {headerName: 'ID', field: '_id', width: 250,sortable: true, filter: true,},
    {headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    
    
  ];

  UserData: any;
  approvalRequestForm: UntypedFormGroup;
  banknameList: any[];
  addmode: boolean;
  editmode: boolean;
  approvalRequestList: any;
  areaCodeList: any;
  bankCodeList: any;
  fieldvisitCodeList: any;
  mStatusList: any;
  sStatusList: any;
  TracingToolsList: any;
  actionstakenList: any;
  uploaded: boolean;
  coordinatorArea: any;
  coordinatorTRT: any;
  agentList: any[];
  login_Details: any;
  selectedRows = [];
  selectedTableId: string;
  gridColumnApi: any;
  createdId: any;
  selectedId: void;
  fintId: any;
  customer_name: any;
  portfolio_type: any;
  bank_name: any;
  FV_Remarks: any;
  FV_Done_Date: any;
  FV_Feedback: any;
  Fv_Feedback: any;
  portfolio_id: any;
  passport_no: string;
  customer_id: any;
  acc_no: any;
  bank_id: any;
  product_id: any;
  finterstal_id: any;
  client_id: any;
  porfolio_id: any;
  bucket_id: any;
  nationality: any;
  cycle: any;
  flow_status: any;
  product_name: any;
  bank_allocation: any;
  bucket: any;
  assigned_by: any;
  assigned_to: any;
  date_of_assign: any;
  touch_status: any;
  agreement_id: any;
  allocated_to: any;
  allocations_status: any;
  cif: any;
  customer_details: any;
  Customer_Name: any;
  date_of_allocations: any;
  total_out_standing: any;
  update_check: any;
  pos: any;
  product_type: any;

  constructor(private formBuilder:UntypedFormBuilder,private router: Router, private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService,) { 
    this.approvalRequestForm = this.formBuilder.group({
      _id:['',Validators.required],
      account_id:['',Validators.required],
      fieldvisitterritory:['',Validators.required],
      fieldvisitarea:['',Validators.required],
      firstaddress:['',Validators.required],
      secondaddress:['',Validators.required],
      fvrqdate:['',Validators.required],
      remarks:['',Validators.required],
      reportingto_id:['',Validators.required],
      assigned_coordinator:[''],
      assigned_agent:[''],
      approval_status :['',Validators.required],
      attachment_url :[''],
      createdby:[''],
      creator_name:[''],
      customer_id:[''],
      client_id :[''],
      bank_id :[''],
      product_id :[''],
      portfolio_id :[''],
      bucket_id :[''],
      finterstal_id :[''],
      passport_no :[''],
      acc_no : [''],
      FV_Done_Date : ['',Validators.required],
      Numbers_Obtained : ['',Validators.required],
      FV_Feedback : ['',Validators.required],
      
      porfolio_id :[''],
     
      bank_name : [''],
     
      nationality :[''],
      cycle : [''],
      flow_status : [''],
    
      product_name : [''],
      bank_allocation : [''],
      bucket :[''],
    
    
      assigned_by :[''],
      assigned_to : [''],
      date_of_assign :[''],
      touch_status : [''],
      agreement_id : [''],
      allocated_to : [''],
      allocations_status : [''],
      cif : [''],
      customer_details : [''],
      Customer_Name : [''],
      date_of_allocations : [''],
      total_out_standing : [''],
      update_check : [''],
      pos: [''],
      product_type: [''],
      
    });
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGetSelectedRowId() {
    const selectedNodes = this.gridApi.getSelectedNodes();
   
    if (selectedNodes.length > 0) {
      const selectedData = selectedNodes[0].data;
      this.createdId = selectedData.createdby;
      this.fintId = selectedData.finterstal_id;
      this.customer_name = selectedData.Customer_Name;
      this.portfolio_type = selectedData.portfolio_type;
      this.bank_name = selectedData.bank_name;
      this.Fv_Feedback = selectedData.FV_Feedback;
      this.passport_no = selectedData.passport_no;
      this.customer_id = selectedData.customer_id;
      this.portfolio_id = selectedData.portfolio_id;
      this.acc_no = selectedData.customer_name.acc_no;
      this.bank_id = selectedData.bank_id;
      this.product_id = selectedData.product_id;
      this.finterstal_id = selectedData.finterstal_id;
      this.client_id = selectedData.client_id;
      this.porfolio_id = selectedData.porfolio_id;
      this.bucket_id = selectedData.bucket_id;
    
      this.nationality = selectedData.nationality;
      this.cycle = selectedData.cycle;
      this.flow_status = selectedData.flow_status;
    
      this.product_name = selectedData.product_name;
      this.bank_allocation = selectedData.bank_allocation;
      this.bucket = selectedData.bucket;
    
    
      this.assigned_by = selectedData.assigned_by;
      this.assigned_to = selectedData.assigned_to;
      this.date_of_assign = selectedData.date_of_assign;
      this.touch_status= selectedData.touch_status;
      this.agreement_id = selectedData.agreement_id;
      this.allocated_to = selectedData.allocated_to;
      this.allocations_status= selectedData.allocations_status;
      this.cif = selectedData.cif;
      this.bucket_id = selectedData.bucket_id;
      // this.Customer_Name = selectedData.Customer_Name.customer_details;
      this.date_of_allocations = selectedData.date_of_allocations;
      this.total_out_standing = selectedData.total_out_standing;
      this.update_check = selectedData.update_check;
      this.customer_details = selectedData.customer_name;
    

      console.log('createdId row ID:', selectedData);
    }
  }

  ngOnInit(): void {
    
    this.addmode = true;
    this.editmode = false;
   
    
    this.UserData = this.storage.get("login_Details");
    this._api.getlist_approval_request({assigned_coordinator:this.UserData._id}).subscribe(data=>{
      if (data['Code']==200) {
        this.approvalRequestList = data['Data']
        this.approvalRequestList.forEach(element => {
          let name = JSON.parse(element.customer_name.customer_details[0],);
          element.agent_name = name[0].AGENT;
          element.Customer_Name = name[0].Customer_Name;
          element.total_out_standing =  name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : '';
        });
        // this.approvalRequestForm.unshift(this.approvalRequestList);
        console.log(this.approvalRequestList,"1234567");

      } else {
        this.approvalRequestList = [];
      }
    });
    this._api.getlist_area_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.areaCodeList = data['Data'];
      } else {
        this.areaCodeList = [];
      }
    });
    this._api.getlist_bank_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.bankCodeList = data['Data'];
      } else {
        this.bankCodeList = [];
      }
    });
    this._api.getlist_fieldvisit_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.fieldvisitCodeList = data['Data'];
      } else {
        this.fieldvisitCodeList = [];
      }
    });
    this._api.getlist_mainStatus_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.mStatusList = data['Data'];
      } else {
        this.mStatusList = [];
      }
    });

    this._api.getlist_subStatus_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.sStatusList = data['Data'];
      } else {
        this.sStatusList = [];
      }
    });

    this._api.getlist_tracingtools().subscribe(data=>{
      if (data['Code'] == 200) {
        this.TracingToolsList = data['Data'];
      } else {
        this.TracingToolsList = [];
      }
    });

    this._api.getlist_actionstaken().subscribe(data=>{
      if (data['Code'] == 200) {
        this.actionstakenList = data['Data'];
      } else {
        this.actionstakenList = [];
      }
    });
    
  }
 

  ontrtchange(event){
    this.coordinatorTRT = event.target.value;
    this.getCoordinatorsList(this.coordinatorArea,this.coordinatorTRT,"Field Visit Agent");
  }
  onareachange(event){
    this.coordinatorArea = event.target.value;
    this.getCoordinatorsList(this.coordinatorArea,this.coordinatorTRT,"Field Visit Agent");
  }

  getCoordinatorsList(area, territory, designation){
    const data = {
      fieldvisitterritory:territory,
      fieldvisitarea:area,
      designation:designation
    }
    this._api.getFieldVisitagents(data).subscribe(data=>{
      if (data['Code'] == 200) {
        this.agentList = data['Data'];
      } else {
        this.agentList = [];
      }
    });

  }

  getFile(event){
    this.uploaded = false;
    const File = event.target.files[0];
    console.log(File);
    this._api.uploadFile(File).subscribe(data=>{
      if (data['Code'] = 200) {
        this.approvalRequestForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = true;
      } else {
        this.approvalRequestForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = false;
      }
    });
    
  }


  editapprovalRequest(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    this.getCoordinatorsList(selectedData[0].fieldvisitarea, selectedData[0].fieldvisitterritory, "Field Visit Agent");
    if (selectedData.length == 1) {
      this.addmode = false;
      this.editmode = true;
      this.approvalRequestForm.patchValue({
        _id:selectedData[0]._id,
        account_id:selectedData[0].account_id,
        fieldvisitterritory:selectedData[0].fieldvisitterritory,
        fieldvisitarea:selectedData[0].fieldvisitarea,
        firstaddress:selectedData[0].firstaddress,
        secondaddress:selectedData[0].secondaddress,
        fvrqdate:selectedData[0].fvrqdate,
        remarks:selectedData[0].remarks,
        reportingto_id:selectedData[0].reportingto_id,
        approval_status :selectedData[0].approval_status,
        attachment_url :selectedData[0].attachment_url,
        createdby:selectedData[0].createdby,
        creator_name:selectedData[0].creator_name,
        assigned_coordinator:selectedData[0].assigned_coordinator,
        assigned_agent:selectedData[0].assigned_agent,
        customer_id:selectedData[0].customer_id,
        client_id :selectedData[0].client_id,
        bank_id :selectedData[0].bank_id,
        product_id :selectedData[0].product_id,
        portfolio_id :selectedData[0].portfolio_id,
        bucket_id :selectedData[0].bucket_id,
        finterstal_id :selectedData[0].finterstal_id,
        passport_no :selectedData[0].passport_no,
        FV_Done_Date : selectedData[0].FV_Done_Date,
      Numbers_Obtained : selectedData[0].Numbers_Obtained,
      FV_Feedback : selectedData[0].FV_Feedback,
      FintId: selectedData[0].fintId,
      Bank_Name: selectedData[0].bank_name,
      Portfolio_Name: selectedData[0].portfolio_type,
      Customer_Name:selectedData[0].customer_name,
      acc_no : selectedData[0].customer_name.acc_no,
      
      
      });
    } else if (selectedData.length > 1) {
      alert("Select Only one Record");
    } else {
      alert("Select atleast one Record");
    }
    
  }

  updateapprovalRequest(){
    console.log("this",this.approvalRequestForm.value);
    
    // if (this.approvalRequestForm.valid) {
      this._api.update_new_fieldvisit(this.approvalRequestForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
          
          this.onreloadPage();

        console.log("data",data);
        
          alert(data['Message']);
          this.sendNotification(this.approvalRequestForm.value);
        } else {
          alert(data['Message']);
        }
       
      });
    // } else {
    //   alert("Please Fill all fields");
    // }
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  cancel(){
    this.addmode = true;
    this.editmode = false;
    this.approvalRequestForm.reset();
  }

  onreloadPage(){
    this.cancel();
    this._api.getlist_approval_request({assigned_coordinator:this.UserData._id}).subscribe(data=>{
      if (data['Code']==200) { 
        this.approvalRequestForm.patchValue({
        Fv_Feedback: data['Data'].FV_Feedback
      });
        this.approvalRequestList = data['Data']
        console.log(this.approvalRequestList,"approvalRequestList");
        
      } else {
        this.approvalRequestList = [];
      }
    });
  }

  sendNotification(_data){
    // console.log(data);
    
    const dataFormat = {
      from: this.UserData._id ,
      to: this.createdId,
      title: "New Notification",
      content: "You have recieved a Field Visit Updated",
      FintId: this.fintId,
      Bank_Name: this.bank_name,
      Portfolio_Name: this.portfolio_type,
      Customer_Name:this.customer_name,
      FV_Feedback: this.Fv_Feedback,
      passport_no : this.passport_no,
      customer_id : this.customer_id,
      portfolio_id : this.portfolio_id,
      acc_no : this.acc_no,
      bank_id : this.bank_id,
      product_id : this.product_id,
      finterstal_id : this.finterstal_id,
      customer_details:this.customer_details,
      bucket_id:this.bucket_id,
      link : '/admin_panel/user/createuser?_id='+this.customer_id,
      read : false,
      status: true ,
      view :false     
    }
    console.log("dataFormat",dataFormat);
    // debugger
    this._api.create_notifications(dataFormat).subscribe(data=>{
      if (data['Code'] == 200) {
        console.log("Sent",data);
      } else {
        console.log("Failed");
      }
    });

  }
  
 
}
